export default __webpack_public_path__ + "static/media/arrow-right-white.88a735ab.svg";